import UIAlert from 'UIComponents/alert/UIAlert';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { connect } from 'react-redux';
import { getIsRestrictedIpAddressAlertVisible } from '../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
const RestrictedIpAddressAlert = ({
  isRestrictedIpAddressAlertVisible
}) => {
  if (!isRestrictedIpAddressAlertVisible) {
    return /*#__PURE__*/_jsx("div", {});
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: I18n.text('login.errors.RESTRICTED_IP_ADDRESS.title'),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "login.errors.RESTRICTED_IP_ADDRESS.body"
    })
  });
};
const mapStateToProps = state => ({
  isRestrictedIpAddressAlertVisible: getIsRestrictedIpAddressAlertVisible(state)
});
export default connect(mapStateToProps)(RestrictedIpAddressAlert);